import { Article, Box, Result } from '@/lib/types';
import { AxiosError } from 'axios';
import { media_client } from '../../';

export default {
    async upload(article_path: string, title: string, category: string, description?: string, selected_tags?: string[]): Promise<Result<string, AxiosError>>{

        try{

            const response = await media_client.put(`/articles`, {
                title,
                description,
                category,
                tags: selected_tags,
                aws_filename: article_path
            });
            return {
                ok: new Box<string>(response.data.id),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        } 

    },
    async update(article_path: string, title: string, description?: string): Promise<Result<boolean, AxiosError>>{

        try{

            await media_client.put(`/articles/${btoa(article_path)}`, {
                title,
                description
            });
            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        } 

    },
    async getSignedUrl(article_path?: string): Promise<Result<{ url: string, filename: string }, AxiosError>>{

        try{

            const response = await media_client.get(`/articles/signed-url`, { params: { article_path: article_path ? btoa(article_path) : null } });
            return {
                ok: new Box<{ url: string, filename: string }>({ url: response.data.signed_url, filename: response.data.filename }),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async load(article_path: string): Promise<Result<Article, AxiosError>>{
        
        try{

            const response = await media_client.get(`/articles/${btoa(article_path)}`);
            return {
                ok: new Box<Article>(response.data.article),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async loadPDF(article_path: string): Promise<Result<string, AxiosError>>{
        
        try{

            const response = await media_client.get(`/articles/get-object-signed-url`, { params: { article_path } });
            return {
                ok: new Box<string>(response.data.url),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },
    async getAll(page: number): Promise<Result<{
        articles: Article[],
        pages: number
    }, AxiosError>>{
        
        try{
            
            const response = await media_client.get('/articles', { params: { page } });
            return {
                ok: new Box<{
                    articles: Article[],
                    pages: number
                }>({
                    articles: response.data.articles,
                    pages: response.data.pages
                }),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    }

}